import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchBouncedEmails, resendBouncedEmails } from "@/api/bouncedEmails";
import type { ResendEntry } from "@/interfaces/bouncedEmails";

export function useBouncedEmails(campaignId: string, enabled = true) {
  return useQuery({
    queryKey: ["bouncedEmails", campaignId],
    queryFn: () => fetchBouncedEmails(campaignId),
    enabled: enabled && !!campaignId,
  });
}

export function useResendBouncedEmails(campaignId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (entries: ResendEntry[]) => resendBouncedEmails(campaignId, entries),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["campaigns"] });
    },
  });
}

export function useRefreshBouncedEmails(campaignId: string) {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries({ queryKey: ["bouncedEmails", campaignId] });
}
